module.exports = __webpack_public_path__ + "static/img/banner.3ec6aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout/banner.png
// module id = riuV
// module chunks = 34